import { OrganizationPatientsTab } from '@/pages/Organizations/Organization';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { organizationId } = Route.useParams();
  return <OrganizationPatientsTab organizationId={organizationId} />;
};

export const Route = createFileRoute('/_auth/organizations/$organizationId/')({
  component: RouteComponent,
});
